import { render, staticRenderFns } from "./DepositReport.vue?vue&type=template&id=525aa3a0&scoped=true&"
import script from "./DepositReport.vue?vue&type=script&lang=js&"
export * from "./DepositReport.vue?vue&type=script&lang=js&"
import style0 from "./DepositReport.vue?vue&type=style&index=0&id=525aa3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525aa3a0",
  null
  
)

export default component.exports